import {
  FETCH_CATEGORIES,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  DELETE_CATEGORY,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
} from "./actionTypes";

// Fetch Categories
export const fetchCategories = (unitId) => ({
  type: FETCH_CATEGORIES,
  payload: { unitId }
});

export const fetchCategoriesSuccess = (roles) => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: roles,
});

export const fetchCategoriesFailure = (error) => ({
  type: FETCH_CATEGORIES_FAILURE,
  payload: error,
});


// Create Category
export const createCategoryRequest = (formData, isEdit) => ({
  type: CREATE_CATEGORY_REQUEST,
  payload: { formData, isEdit },
});

export const createCategorySuccess = (response) => ({
  type: CREATE_CATEGORY_SUCCESS,
  payload: response,
});

export const createCategoryFailure = (error) => ({
  type: CREATE_CATEGORY_FAILURE,
  payload: error,
});

// Delete Category
export const deleteCategory = (formdata) => ({
  type: DELETE_CATEGORY,
  payload: formdata,
});

export const deleteCategorySuccess = (response) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: response,
});

export const deleteCategoryFailure = (error) => ({
  type: DELETE_CATEGORY_FAILURE,
  payload: error,
});